<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <table>
              <tr>
                <td><a @click="openPage('/formReport/add_autocollection')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a></td>

              </tr>
            </table>
          </div>
          <div class="col-sm-5 text-right">
            <table>
              <tr>
                <td><a @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="onChange" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
            <!-- <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0 overflow-x">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="xl" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(form_type)>
            Outstanding
          </template>
          <template v-slot:cell(id)="data">
            {{data.item.member_id ? data.item.member_id : '-'}}
          </template>
          <template v-slot:cell(name)="data">
            <template v-if="data.item.member">
              {{data.item.member ? data.item.member.first_name + ' ' + data.item.member.last_name : '-'}}

            </template>
          </template>
          <template v-slot:cell(phone)="data">
            {{data.item.member ? data.item.member.phone_number : ''}}
          </template>
          <template v-slot:cell(email)="data">
            {{data.item.member ? data.item.member.email : '-'}}
          </template>
          <template v-slot:cell(type)="data">
            {{data.item.member ? data.item.member.membership_last_buy_name : '-'}}
          </template>
          <template v-slot:cell(monthly_fee)="data">
            {{data.item.monthly_fee}}
          </template>
          <template v-slot:cell(monthly)="data">
            {{data.item.month}}
          </template>
          <template v-slot:cell(total)="data">
            {{data.item.outstanding_total}}
          </template>
          <template v-slot:cell(late_payment)="data">
            {{data.item.late_payment}}
          </template>
          <template v-slot:cell(late_payment_total)="data">
            {{data.item.late_payment_total}}
          </template>
          <template v-slot:cell(payment_total)="data">
            {{data.item.payment_total}}
          </template>
          <template v-slot:cell(emply_id)="data">
            {{data.item.member && data.item.member.sales ? data.item.member.sales.id : '-'}}
          </template>
          <template v-slot:cell(membership_advisor_name)="data">
            {{data.item.member && data.item.member.sales ? data.item.member.sales.fullname : '-'}}
          </template>
          <template v-slot:cell(is_proccess)="data">
            <template v-if="data.item.is_proccess == 1">
              <b-badge :variant="'success'" >Success</b-badge>
            </template>
            <template v-if="data.item.is_proccess == 0">
              <b-badge :variant="'warning'" >Waiting...</b-badge>
            </template>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button size="sm" @click="editForm('/allForm/edit?id=' + data.item.id)" class="btn-table warning mr-1">
            <i class="far fa-edit"></i> Edit
            </b-button>
            <b-button size="sm" v-on:click="deleteForm(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="p-15 pt-0">
      <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
          :total-pages="totalPage"
          @page-changed="pageOneChanged"
          prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'allForm',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'periode',
          label: 'Periode',
          sortable: true
        },
        {
          key: 'member.branch.name',
          label: 'Club',
          sortable: true
        },
        {
          key: 'member_id',
          label: 'Member ID',
          sortable: true
        },
        // {
        //   key: 'member',
        //   label: 'Member',
        //   formatter: (value, key, item) => {
        //     return
        //   },
        //   sortable: true
        // },
        {
          key: 'name',
          label: 'Member',
          sortable: true
        },
        {
          key: 'account',
          label: 'Account',
          sortable: true
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: true
        },
        {
          key: 'result',
          label: 'Result',
          sortable: true
        },
        {
          key: 'member.membership.name',
          label: 'Membership',
          sortable: true
        },
        {
          key: 'is_proccess',
          label: 'Process',
          sortable: false
        }
      ],
      items: [],
      getId: Auth.Session.get().paradigm_id,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    onChange(selectedDates, dateStr, instance) {
      // console.log('test2', dateStr)
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      // console.log(dates)
      axios({
        method: 'get',
        url: 'crm/v1/export/auto_collection_report?start_date='+dates[0]+'&end_date='+dates[1],
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Auto Collection Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteForm(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/form/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/form_auto_collection?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData + '&start_date=' + dates1[0] + '&end_date=' + dates1[1]).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
